import { type FC } from 'react';
import cx from 'classnames';

import { formatPercentage } from 'src/lib/format';

import { useStyles } from './useStyles';

const PERCENTAGE_METRIC = 'Adoption rate (YTD)';

interface KpiCardProps {
  className?: string;
  metric: string;
  value: number | string;
  definition: string;
}

export const KpiCard: FC<KpiCardProps> = ({ className, metric, value, definition }) => {
  const styles = useStyles();

  const formattedValue =
    metric === PERCENTAGE_METRIC && typeof value === 'number'
      ? formatPercentage(value * 100, '0')
      : value;

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.metric}>{metric}</div>
      <div className={styles.value}>{formattedValue}</div>
      <div className={styles.definition}>{definition}</div>
    </div>
  );
};
